import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da4cc0ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "servicePackageBuyLog" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("关闭")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
const loading = ref(true);
const detailDialogVisible = ref(false);

const bindData = reactive({
  paymentWayOptions: [
    {
      value: "",
      label: "全部",
    },
    {
      value: "1",
      label: "微信",
    },
    {
      value: "2",
      label: "支付宝",
    },
    {
      value: "3",
      label: "现金",
    },
    {
      value: "4",
      label: "赠送",
    },
    {
      value: "5",
      label: "电子账户",
    },
  ],
  servicePackageBuyLogPageParams: {
    curPage: 1,
    pageSize: 10,
    filtrate: {
      paymentWay: "",
      keyword: "",
    },
  },
  servicePackageBuyLogPageResult: {
    status: 2000,
    msg: "成功",
    result: [],
    totalCount: 0,
  },
  servicePackageAccountPageParams: {
    curPage: 1,
    pageSize: 10,
    filtrate: {
      buyOrderNo: "",
      keyword: "",
    },
  },
  servicePackageAccountPageResult: {
    status: 2000,
    msg: "成功",
    result: [],
    totalCount: 0,
  },
});

const handleSizeChangeEvent = (value: any) => {
  bindData.servicePackageBuyLogPageParams.pageSize = value;
  bindData.servicePackageBuyLogPageParams.curPage = 1;
  searchEvent();
};

const handleCurrentChangeEvent = (value: any) => {
  bindData.servicePackageBuyLogPageParams.curPage = value;
  searchEvent();
};

const searchEvent = () => {
  store
    .dispatch("membershipFeesModule/pageServicePackageBuyLogList", bindData.servicePackageBuyLogPageParams)
    .then(
      (data) => {
        //成功
        for (var index in data.result) {
          const obj = data.result[index];
          //支付方式 1：微信 2：支付宝 3:现金 4：赠送
          switch (Number(obj.paymentWay)) {
            case 1:
              obj.paymentWayName = "微信";
              break;
            case 2:
              obj.paymentWayName = "支付宝";
              break;
            case 3:
              obj.paymentWayName = "线下现金";
              break;
            case 4:
              obj.paymentWayName = "赠送";
              break;
            case 5:
              obj.paymentWayName = "电子账户";
              break;
            default:
              obj.paymentWayName = "--";
              break;
          }
        }
        bindData.servicePackageBuyLogPageResult = data;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const showDetailEvent = (index: number, row: Object) => {
  detailDialogVisible.value = true;
  bindData.servicePackageAccountPageParams.filtrate.buyOrderNo =  row.buyOrderNo;
  store
    .dispatch("membershipFeesModule/pageServicePackageAccountList", bindData.servicePackageAccountPageParams)
    .then(
      (data) => {
        //成功
        for (var index in data.result) {
          const obj = data.result[index];
          //支付方式 1：微信 2：支付宝 3:现金 4：赠送
          switch (Number(obj.itemType)) {
            case 1:
              obj.itemName = "活动发布数量";
              break;
            case 2:
              obj.itemName = "活动报名数量";
              break;
            case 3:
              obj.itemName = "活动报名信息数量";
              break;
            case 4:
              obj.itemName = "站内信群发数量";
              break;            
            default:
              obj.itemName = "--";
              break;
          }
        }
        bindData.servicePackageAccountPageResult = data;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

searchEvent();


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_container, { class: "servicePackageBuyLog-search" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, { class: "servicePackageBuyLog-search-lt" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(bindData).servicePackageBuyLogPageParams.filtrate.paymentWay,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).servicePackageBuyLogPageParams.filtrate.paymentWay) = $event)),
                    placeholder: "流水号\\交易名称\\操作人",
                    size: "large",
                    onChange: searchEvent
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).paymentWayOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { class: "servicePackageBuyLog-search-lt-text" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "",
                    size: "large",
                    modelValue: _unref(bindData).servicePackageBuyLogPageParams.filtrate.keyword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).servicePackageBuyLogPageParams.filtrate.keyword) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { class: "servicePackageBuyLog-search-lt-btn" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    size: "large",
                    onClick: searchEvent
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _unref(bindData).servicePackageBuyLogPageResult.result,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "buyOrderNo",
            label: "订单号",
            width: "200"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "服务包名",
            width: "150"
          }),
          _createVNode(_component_el_table_column, {
            prop: "unitPrice",
            label: "单价",
            width: "60"
          }),
          _createVNode(_component_el_table_column, {
            prop: "packageCount",
            label: "购买包数量",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "totalAmount",
            label: "总价",
            width: "80"
          }),
          _createVNode(_component_el_table_column, {
            prop: "paymentAmount",
            label: "实付金额",
            width: "80"
          }),
          _createVNode(_component_el_table_column, {
            prop: "paymentWayName",
            label: "支付方式",
            width: "80"
          }),
          _createVNode(_component_el_table_column, {
            prop: "outTradeNo",
            label: "交易流水单号",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "cashFee",
            label: "现金金额",
            width: "80"
          }),
          _createVNode(_component_el_table_column, {
            prop: "couponFee",
            label: "用券金额",
            width: "80"
          }),
          _createVNode(_component_el_table_column, {
            prop: "buyTime",
            label: "购买时间",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "gmtActiveDays",
            label: "有效期(天)",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "remark",
            label: "备注",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "200"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_unref(ElButton), {
                type: "text",
                size: "small",
                onClick: ($event: any) => (showDetailEvent(scope.$index, scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ]),
      _createVNode(_component_el_container, { class: "servicePackageBuyLog-page_toolbar" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_pagination, {
            currentPage: _unref(bindData).servicePackageBuyLogPageParams.curPage,
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).servicePackageBuyLogPageParams.curPage) = $event)),
            "page-size": _unref(bindData).servicePackageBuyLogPageParams.pageSize,
            "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).servicePackageBuyLogPageParams.pageSize) = $event)),
            "page-sizes": [10, 20, 50, 100],
            layout: "total, sizes, prev, pager, next, jumper",
            total: _unref(bindData).servicePackageBuyLogPageResult.totalCount,
            "onUpdate:total": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).servicePackageBuyLogPageResult.totalCount) = $event)),
            onSizeChange: handleSizeChangeEvent,
            onCurrentChange: handleCurrentChangeEvent
          }, null, 8, ["currentPage", "page-size", "total"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: detailDialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((detailDialogVisible).value = $event)),
      title: "权益项",
      width: "40%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_unref(ElButton), {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (detailDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: _unref(bindData).servicePackageAccountPageResult.result,
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "itemName",
                label: "权益名称",
                width: "200"
              }),
              _createVNode(_component_el_table_column, {
                prop: "itemCount",
                label: "权益总数量",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "balance",
                label: "权益余量",
                width: "80"
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, loading.value]
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})